import { useCallback } from "react";

import { type FetchResult, type MutationFunctionOptions, useMutation } from "@apollo/client";

import { type ApolloResult } from "../../shared/models";
import { uploadFile as uploadFileMutation } from "../api/mutations/uploadFile";
import { type UploadFileMutation, type UploadFileMutationVariables } from "../api/mutations/uploadFile.gql-generated";

export const useUploadFile = (): ApolloResult<{
    uploadFile: (
        options: MutationFunctionOptions<UploadFileMutation, UploadFileMutationVariables>,
    ) => Promise<FetchResult<UploadFileMutation>>;
}> => {
    const [executeUploadFile, { loading, error }] = useMutation<UploadFileMutation, UploadFileMutationVariables>(
        uploadFileMutation,
    );

    const uploadFile = useCallback(
        async (options: MutationFunctionOptions<UploadFileMutation, UploadFileMutationVariables>) => {
            return executeUploadFile(options);
        },
        [executeUploadFile],
    );

    return { uploadFile, loading, error };
};
